import { render, staticRenderFns } from "./ReleaseTicketsModal.vue?vue&type=template&id=45e2cef1&"
import script from "./ReleaseTicketsModal.vue?vue&type=script&lang=js&"
export * from "./ReleaseTicketsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports